import { createApiCallActions } from '../../../../common/store/generic.actions';
import {
  CommissionModel,
  CommissionPreviewModel,
  CommissionReportModel as CommissionReportModel,
  CommissionReportSalesPersonCommissionsDashboardModel,
  CommissionReportSalesPersonProductionDashboardModel,
} from './types';

export const commissionActions = {
  getById: createApiCallActions<CommissionModel>('commission', 'getById'),
  getCommissionsPreview: createApiCallActions<CommissionPreviewModel[]>(
    'commission',
    'getCommissionsPreview',
  ),
  add: createApiCallActions<CommissionPreviewModel[]>('commission', 'add'),
  addSalesPersonCommissionPayment: createApiCallActions<boolean>(
    'commission',
    'addSalesPersonCommissionPayment',
  ),
  deleteSalesPersonCommissions: createApiCallActions<boolean>(
    'commission',
    'deleteSalesPersonCommissions',
  ),
  deleteSalesPersonCommissionPayment: createApiCallActions<boolean>(
    'commission',
    'deleteSalesPersonCommissionPayment',
  ),
  getCompanyCommissions: createApiCallActions<CommissionReportModel[]>(
    'commission',
    'getCompanyCommissions',
  ),
  getExcludedTaxAnnualFees: createApiCallActions<CommissionReportModel[]>(
    'commission',
    'getExcludedTaxAnnualFees',
  ),
  getApplicationFeesReport: createApiCallActions<CommissionReportModel[]>(
    'commission',
    'getApplicationFeesReport',
  ),
  getSalesPersonProductionDashboardData:
    createApiCallActions<CommissionReportSalesPersonProductionDashboardModel>(
      'commission',
      'getSalesPersonProductionDashboardData',
    ),
  getSalesPersonCommissionsDashboardData:
    createApiCallActions<CommissionReportSalesPersonCommissionsDashboardModel>(
      'commission',
      'getSalesPersonCommissionsDashboardData',
    ),
};

export type CommissionAction = typeof commissionActions;
